// extracted by mini-css-extract-plugin
export var copyableField = "_ny-4";
export var customerBadge = "_ny-0";
export var customerInfoTitle = "_ny-2";
export var details = "_ny-1";
export var dropdownContainer = "_ny-5";
export var dropdownImage = "_ny-6";
export var editAssigneeForm = "_ny-a";
export var editButton = "_ny-3";
export var email = "_ny-7";
export var hidden = "_ny-d";
export var input = "_ny-8";
export var saveButton = "_ny-b";
export var shopifyIcon = "_ny-c";
export var suggestionBadge = "_ny-e";
export var suggestionText = "_ny-f";
export var username = "_ny-9";